import { render, staticRenderFns } from "./VrschoolTest2View.vue?vue&type=template&id=918a9e2e&scoped=true&"
import script from "./VrschoolTest2View.vue?vue&type=script&lang=js&"
export * from "./VrschoolTest2View.vue?vue&type=script&lang=js&"
import style0 from "./VrschoolTest2View.vue?vue&type=style&index=0&id=918a9e2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918a9e2e",
  null
  
)

export default component.exports